import { Colors } from 'baseStyles/enums/colors'
import React from 'react'
import Button from 'schoolUiComponents/basic/Button'
import CleverIconSVG from "../../assets/clever-icon.svg";
import Text from 'schoolUiComponents/basic/Text';
import Box from 'schoolUiComponents/basic/Box';
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox';
import TeacherSignupStyles from '../../style';
import { pushEventToGTM } from '../../../commonHelpers/pushEventToGTM'
import { getSignupMethod } from '../../utils';
import useSignupCookie from 'hooks/useSignupCookie';

const client_id = IS_PROD ? "5f1af460a51560d91249" : "68f5d81958830d518d7b";

const CleverButton = () => {

    const themeStyles = TeacherSignupStyles();

    const { setCookie } = useSignupCookie();
    
    const system_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const onCleverClick = () => {
        // Setting cookie with signup
        setCookie('userSignedUp', 'true', {
            path: '/',
            secure: true,
            sameSite: 'Strict'
        });
        
        const stateData = {
            time_zone: system_timezone
        };
        const state = btoa(JSON.stringify(stateData));
        pushEventToGTM('clicked_teacher_signup_cta', { 'Click Text': 'Sign up' ,'Parent Signup Method': getSignupMethod()});
        window.location.href = `https://clever.com/oauth/authorize?response_type=code&redirect_uri=${window.location.origin}/users/auth/clever&client_id=${client_id}&state=${encodeURIComponent(state)}`;
    }

    return (
        <FlexBox
            flex={1} 
            width={themeStyles.socialButtons?.width}
            className='clever'
            data-clicked="Clicked Clever Signup" 
            data-onclick-url={`https://clever.com/oauth/authorize?response_type=code&amp;redirect_uri=${window.location.origin}/users/auth/clever&amp;client_id=${client_id}`}
            data-frompage="Signup Screen" 
            data-track="false" 
            data-clickedon="Clever Signup" 
            data-directform="false" 
            data-provider="clever" 
            data-networkname="Clever"
            {...themeStyles.socialCtaBtns}
        >
            <Button
                primary
                width={`100%`}
                height="58px"
                onClick={onCleverClick}
                backgroundColor={Colors.LIGHT_BLUE_5}
                hover={{ backgroundColor: Colors.NAVY_BLUE_2, cursor: 'pointer' }}
                dataTestId="social-auth-btn-clever"
            >
                <FlexBox center fullWidth>
                    <CleverIconSVG />
                    <Box margin={`0 0 0 10px`}>
                        <Text.H4 color={Colors.WHITE}>
                            Sign up with Clever
                        </Text.H4>
                    </Box>
                </FlexBox>
            </Button>
        </FlexBox>
    )
}

export default CleverButton